import { useQuery } from "@tanstack/react-query";
import { sidebarService } from "../api/services/sidebar/sidebarService";

export const useAllMenus = () => {
  return useQuery({
    queryKey: ["sidebar", "all-menus"],
    queryFn: sidebarService.getAllMenus,
    retry: 3,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};
